/**
 * SF-4845: why Start (or Resume) is off when the caller's platform edit scope does not allow it.
 * Nothing while the scope allows it.
 */
import { Alert, Button, Typography } from 'antd';
import type { CopyStartScope } from '../api/envCopyClient';

export const EditScopeNotice: React.FC<{ scope: CopyStartScope; action: string }> = ({
  scope,
  action,
}) => {
  if (scope.canStart) return null;
  if (scope.checking) {
    return <Typography.Text type="secondary">Checking your edit access...</Typography.Text>;
  }
  if (scope.failed) {
    return (
      <Alert
        type="error"
        showIcon
        message={`Could not check your edit access, so ${action} is off.`}
        action={
          <Button size="small" onClick={() => void scope.refetch()}>
            Retry
          </Button>
        }
      />
    );
  }
  return (
    <Alert
      type="info"
      showIcon
      message={`${action[0].toUpperCase()}${action.slice(1)} needs edit access to the whole platform.`}
    />
  );
};
